import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BooleanPipe, NoDataComponent } from '@web/shared/ui';
import { isNotEmptyArray } from '@web/utils';
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionPanel,
} from 'primeng/accordion';
import { SummernoteHtmlPreviewComponent } from '@web/shared/external';
import { BoxComponentGroupView } from '../../models';
import { BoxComponentGroupCosmeticsTableComponent } from '../box-component-group-cosmetics-table/box-component-group-cosmetics-table.component';

@Component({
  selector: 'app-box-component-groups-preview',
  imports: [
    Accordion,
    AccordionContent,
    AccordionHeader,
    AccordionPanel,
    BooleanPipe,
    BoxComponentGroupCosmeticsTableComponent,
    CommonModule,
    NoDataComponent,
    SummernoteHtmlPreviewComponent,
  ],
  templateUrl: './box-component-groups-preview.component.html',
  styleUrl: './box-component-groups-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoxComponentGroupsPreviewComponent {
  public readonly groups = input.required<BoxComponentGroupView[]>();
  public readonly showAvailableQuantity = input(true);
  public readonly showRemainingQuantity = input(true);
  public readonly showQuestionnaireVisibility = input(true);

  protected readonly isNotEmptyArray = isNotEmptyArray;
}
